import loadsJs from 'loads-js';

import { POS_SCRIPT_BMAP, POS_SCRIPT_GMAP } from '../settings/pointOfSale';
import { mapScriptLoaded } from '../actions/pointOfSale';
import { getChannel } from '../actions/nav';
import { countryCode } from './country';

export default function(dispatch) {
  if (countryCode !== 'CN') {
    loadsJs(POS_SCRIPT_GMAP(getChannel()), () => mapScriptLoaded(dispatch, window.google.maps));
  } else {
    window.HOST_TYPE = '2';
    window.BMap_loadScriptTime = (new Date()).getTime();
    loadsJs(POS_SCRIPT_BMAP(Date.now()), () => mapScriptLoaded(dispatch, window.BMap));
  }
}



// WEBPACK FOOTER //
// ./src/services/map.js